import './AboutMe.css';

import { monthDiff, calculateAge } from '../../Helpers/date.js';
import { useProjects } from '../../Context/ProjectContext';

const AboutMe = () => {
  const projects = useProjects();

  const facts = [
    {
      title: 'Work Experince',
      value: monthDiff(new Date(2022, 4, 1), new Date()) + ' Months',
    },
    { title: 'Projects', value: projects.length },
    { title: 'Field', value: 'IT' },
    { title: 'Education', value: 'Compuer Science' },
  ];
  return (
    <>
      <section id="about" className="about">
        <div className="about-heading-container">
          <h2>About me</h2>
        </div>

        <div className="bg-wrapper">
          <div className="about-paragraph-container">
            <h3>Education</h3>
            <p>
              I am a {calculateAge(new Date(1999, 3, 26))}-year-old, positive
              and enthusiastic individual living in Brabrand, Aarhus. I attended
              Tranbjergskolen (primary school) and later pursued the Higher
              Technical Exam (HTX) with a focus on Information Technology at the
              B-level and Mathematics at the A-level, driven by my passion for
              IT.
            </p>
            <p>
              In June 2023, I completed my Computer Science (AP) degree and am
              now continuing my studies as a Software Engineering student.
            </p>
          </div>

          <div className="about-paragraph-container">
            <h3>Working way</h3>

            <p>
              The way I am as a person is that I am curious and inquisitive. I
              want to constantly develop myself, both personally and
              professionally, and on the basis of that I can become a better
              version of myself.
            </p>
            <p>
              My working method when it comes to tasks, whether it is
              educational or personal, I work systematically and purposefully
              and plan my work tasks, so I can form an overview and meet
              deadlines and complete the work tasks.
            </p>
            <p>
              I learn and grasph knowledge by implemententing it in projects to
              get a deeper and better understanding of how something works.
            </p>
          </div>

          <div className="about-paragraph-container">
            <h3>Work Experience</h3>
            <p>
              Gained experience in software development through student jobs at
              Aarhus University, the Danish Technological Institute, and
              Schibsted. Worked with backend development (C#, MSSQL,
              Microservices, WebAPI), Robotic Process Automation, and web
              development (ReactJS, APIs).
            </p>
          </div>

          <div className="about-paragraph-container">
            <h3>Ambitions</h3>
            <p>
              I have high ambitions regarding my education and carrer. I'm
              currently a software engineer student at Aarhus University. My
              vision for the future is to develop enterprise web applications.
            </p>
          </div>
        </div>
        {/*
        <div className="about-facts-container">
          {facts.map((fact, index) => {
            return (
              <section className="about-fact" key={index}>
                <h3>{fact.title}</h3>
                <h4>{fact.value}</h4>
              </section>
            );
          })}
        </div> 
     */}
      </section>
    </>
  );
};

export default AboutMe;
